import request from '@/utils/request'

export function getStat() {
  return request({
    url: '/xm/getstat',
    method: 'get'
  })
}

